import React from "react";
import {IconProps} from "../../../../../icons/icon-props-interface";

const IconLogout: React.FC<IconProps> = ({color = 'var(--color-primary-2-50)'}) => {
    return (
        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7058 10.5882V8.23529H9.9999V5.88235H14.7058V3.52941L19.4117 7.05882L14.7058 10.5882ZM12.3528 14.1176H7.64696V3.52941L2.94108 1.17647H12.3528V4.70588H13.5293V1.17647C13.5293 0.529412 12.9999 0 12.3528 0H1.76461C1.11755 0 0.588135 0.529412 0.588135 1.17647V14.5647C0.588135 15.0235 0.846958 15.4235 1.23519 15.6353L7.64696 18.8353V15.2941H12.3528C12.9999 15.2941 13.5293 14.7647 13.5293 14.1176V9.41177H12.3528V14.1176Z"
                fill={color}
            />
        </svg>
    );
}

export default IconLogout;